import { render, staticRenderFns } from "./RoomMap.vue?vue&type=template&id=18a3c090&scoped=true"
import script from "./RoomMap.vue?vue&type=script&lang=ts"
export * from "./RoomMap.vue?vue&type=script&lang=ts"
import style0 from "./RoomMap.vue?vue&type=style&index=0&id=18a3c090&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3c090",
  null
  
)

export default component.exports